import React, { useState, useEffect } from "react";
import "./Home.scss";
import { useParams } from "react-router-dom";
import axios from "axios";
import bg from "../img/bgg.jpg";

// Import all images manually (recommended approach for reliability)
// Old Collection Images
import assorted_Old from "../img/proImg/ASSORTED_old.png";
import caramel_Old from "../img/proImg/CARAMEL_old.png";
import coconut_Old from "../img/proImg/COCONUT_old.png";
import dark_Old from "../img/proImg/DARK_old.png";
import extradark_Old from "../img/proImg/EXTRADARK_old.png";
import milk_Old from "../img/proImg/milk_old.png";
import nas_Old from "../img/proImg/NAS_old.png";
import white_Old from "../img/proImg/WHITE_old.png";

// New Collection Images (2026)
import assorted_New from "../img/proImg/ASSORTED_new.png";
import caramel_New from "../img/proImg/CARAMEL_new.png";
import coconut_New from "../img/proImg/COCONUT_new.png";
import dark_New from "../img/proImg/DARK_new.png";
import extradark_New from "../img/proImg/EXTRADARK_new.png";
import milk_New from "../img/proImg/milk_new.png";
import nas_New from "../img/proImg/NAS_new.png";
import white_New from "../img/proImg/WHITE_new.png";

// Fallback images
import fallbackOld from "../img/proImg/fallback_old.png";
import fallbackNew from "../img/proImg/fallback_new.png";

// Product display names mapping
const productDisplayNames = {
  ASSORTED: "CHOCODATE ASSORTED",
  CARAMEL: "CHOCODATE CARAMEL",
  COCONUT: "CHOCODATE COCONUT",
  DARK: "CHOCODATE DARK",
  EXTRADARK: "CHOCODATE EXTRA DARK",
  MILK: "CHOCODATE MILK",
  NAS: "CHOCODATE NO ADDED SUGAR DARK",
  WHITE: "CHOCODATE WHITE",
};

// Image mapping for old products (use imported variables) - FIXED: using lowercase keys
const oldImages = {
  assorted: assorted_Old,
  caramel: caramel_Old,
  coconut: coconut_Old,
  dark: dark_Old,
  extradark: extradark_Old,
  milk: milk_Old,
  nas: nas_Old,
  white: white_Old,
};

// Image mapping for new products (use imported variables) - FIXED: using lowercase keys
const newImages = {
  assorted: assorted_New,
  caramel: caramel_New,
  coconut: coconut_New,
  dark: dark_New,
  extradark: extradark_New,
  milk: milk_New,
  nas: nas_New,
  white: white_New,
};

// Default fallback images (external URL as backup)
const defaultImage =
  "https://admin.chocodate.ca/uploads/8_1_1_11zon_4bcae3bc84.jpg";

const Home = () => {
  const { qr } = useParams();
  const [imageAnimation, setImageAnimation] = useState("image-reveal-glow");

  // Image loading states
  const [oldImageLoaded, setOldImageLoaded] = useState(false);
  const [newImageLoaded, setNewImageLoaded] = useState(false);
  const [oldImageUrl, setOldImageUrl] = useState("");
  const [newImageUrl, setNewImageUrl] = useState("");

  // Product info states
  const [productName, setProductName] = useState("");
  const [displayName, setDisplayName] = useState("");

  // Check if THIS SPECIFIC QR was seen by this browser
  const [hasSeen, setHasSeen] = useState(
    localStorage.getItem("productSeen") === qr,
  );

  const [loading, setLoading] = useState(true);
  const [qrStatus, setQrStatus] = useState(null);
  const [stage, setStage] = useState("verifying");
  const [introTimer, setIntroTimer] = useState(9);
  const [productTimer, setProductTimer] = useState(9);

  console.log("productName", productName);

  const markAsUsed = async () => {
    try {
      await axios.post("/update-status", { qr: qr, status: "used" });
    } catch (error) {
      console.error("Error updating status");
    }
  };

  // Array of available animations
  const animations = [
    // "image-reveal-glow",
    // "image-reveal-slide",
    // "image-reveal-zoom",
    // "image-reveal-rotate",
    // "image-reveal-flip",
    "image-reveal-bounce",
    // "image-reveal-shine",
    // "image-reveal-ripple",
    // "image-reveal-swing",
    // "image-reveal-flash",
    // "image-reveal-morph",
    // "image-reveal-glitch",
    // "image-reveal-dust",
  ];

  // Function to get image URL based on product name and version
  const getProductImageUrl = (productName, version) => {
    if (!productName) {
      return version === "old" ? fallbackOld : fallbackNew;
    }

    const productKey = productName.toLowerCase();

    if (version === "old") {
      return oldImages[productKey] || fallbackOld;
    } else {
      return newImages[productKey] || fallbackNew;
    }
  };

  // Fetch product name from QR code API
  useEffect(() => {
    const fetchProductFromQR = async () => {
      if (!qr) {
        setStage("expired");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        // Call your API to get product name from QR code
        const response = await axios.post(`/get-verify/${qr}`);
        const status = response.data.status;
        const productNameFromAPI =
          response.data.name ||
          response.data.productName ||
          response.data.product;
        setQrStatus(status);
        if (productNameFromAPI) {
          // FIXED: Keep original case from API, don't convert
          const productKey = productNameFromAPI;
          setProductName(productKey);
          // Get display name from mapping or capitalize the product name
          const display =
            productDisplayNames[productKey] ||
            productKey.charAt(0).toUpperCase() +
              productKey.slice(1).toLowerCase();
          setDisplayName(display);
          // Load old and new images based on product name
          const oldImgUrl = getProductImageUrl(productKey, "old");
          const newImgUrl = getProductImageUrl(productKey, "new");
          console.log(`Loading images for: ${productKey}`);
          console.log(
            `Old image: ${typeof oldImgUrl === "string" ? oldImgUrl.substring(0, 50) : "imported"}`,
          );
          console.log(
            `New image: ${typeof newImgUrl === "string" ? newImgUrl.substring(0, 50) : "imported"}`,
          );
          setOldImageUrl(oldImgUrl);
          setNewImageUrl(newImgUrl);
        } else {
          // No product name in response
          console.error("No product name in API response");
          setOldImageUrl(fallbackOld);
          setNewImageUrl(fallbackNew);
          setDisplayName("Premium Collection");
        }
        // Check if QR is already used
        if (localStorage.getItem("productSeen") === qr || status === "used") {
          setStage("expired");
        } else {
          setStage("intro");
        }
      } catch (error) {
        console.error("Error fetching product:", error);
        setStage("expired");
      } finally {
        setLoading(false);
      }
    };
    fetchProductFromQR();
  }, [qr]);

  // When stage changes to 'active', pick a random animation
  useEffect(() => {
    if (stage === "active") {
      const randomAnim =
        animations[Math.floor(Math.random() * animations.length)];
      setImageAnimation(randomAnim);
    }
  }, [stage]);

  // Timer logic
  useEffect(() => {
    if (stage === "expired" || loading) return;
    let interval;
    if (stage === "intro") {
      interval = setInterval(() => {
        setIntroTimer((prev) => {
          if (prev <= 1) {
            setStage("active");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    if (stage === "active") {
      interval = setInterval(() => {
        setProductTimer((prev) => {
          if (prev <= 1) {
            handleExpiry();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [stage, loading]);

  const handleExpiry = () => {
    setStage("expired");
    setHasSeen(true);
    localStorage.setItem("productSeen", qr);
    markAsUsed();
  };

  // Preload images
  useEffect(() => {
    if (oldImageUrl) {
      const img = new Image();
      img.src = oldImageUrl;
      img.onload = () => {
        console.log("Old image loaded successfully");
        setOldImageLoaded(true);
      };
      img.onerror = () => {
        console.error("Failed to load old image:", oldImageUrl);
        setOldImageLoaded(true); // Still mark as loaded to remove placeholder
      };
    }
    if (newImageUrl) {
      const img = new Image();
      img.src = newImageUrl;
      img.onload = () => {
        console.log("New image loaded successfully");
        setNewImageLoaded(true);
      };
      img.onerror = () => {
        console.error("Failed to load new image:", newImageUrl);
        setNewImageLoaded(true); // Still mark as loaded to remove placeholder
      };
    }
  }, [oldImageUrl, newImageUrl]);

  if (loading)
    return (
      <div className="reveal-container gradient-background">
        <div className="loader">
          {" "}
          <span>Verifying...</span>
        </div>
      </div>
    );

  return (
    <div
      className="reveal-container gradient-background"
      // onContextMenu={(e) => e.preventDefault()}
      // style={{
      //   backgroundImage: `linear-gradient(00deg, rgba(255, 255, 255, 0.65) 0%, rgba(255, 255, 255, 0.4) 35%, rgba(255, 255, 255, 0) 100%), url(${bg})`,
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      // }}
    >
      <div className="content-card">
        {/* PHASE 1: INTRO (SHOWING OLD PRODUCT) */}
        {stage === "intro" && (
          <div className="intro-view">
            <div className="teaser-wrapper">
              <div className="image-wrapper">
                {!oldImageLoaded && (
                  <div className="image-placeholder shimmer">
                    <div className="placeholder-content">
                      <div className="loading-spinner"></div>
                      <span>Loading current design...</span>
                    </div>
                  </div>
                )}
                <img
                  src={oldImageUrl}
                  alt={`${displayName} - Current Version`}
                  className={`product-image ${oldImageLoaded ? "loaded" : "loading"}`}
                  style={{
                    filter: oldImageLoaded ? "blur(0)" : "blur(20px)",
                    opacity: oldImageLoaded ? 1 : 0.6,
                    transition: "filter 0.5s ease, opacity 0.5s ease",
                  }}
                  onLoad={() => setOldImageLoaded(true)}
                  onError={(e) => {
                    console.error("Image error, using fallback");
                    e.target.src = fallbackOld;
                  }}
                />
              </div>
            </div>
            <div className="text-content">
              {/* <span className="status-label">
                Current Collection • {new Date().getFullYear() - 1}
              </span> */}
              <div style={{ marginBottom: "20px" }}>
                <h2>{displayName}</h2>
              </div>
              <div className="progress-timer">
                <div className="progress-bar-container">
                  <div
                    className="progress-bar-fill"
                    style={{
                      width: `${(introTimer / 9) * 100}%`,
                      backgroundColor: introTimer <= 3 ? "#ff3b30" : "#d4af37",
                    }}
                  />
                </div>
                {/* <span className="timer-text">{introTimer}s remaining</span> */}
              </div>

              <strong style={{ color: "white", marginBottom: "30px" }}>
                Now it’s elevated
              </strong>
            </div>
          </div>
        )}
        {/* PHASE 2: PRODUCT ACTIVE (SHOWING NEW PRODUCT) */}
        {stage === "active" && (
          <div className="product-view fade-in">
            <span className="brand-label">
              Reimagined Outside <br /> <em>Same Taste You Love</em>
            </span>

            {/* <div className="mini-timer active-timer">
              <span className="timer-text">Ends in {productTimer}s</span>
            </div> */}
            <div className="image-wrapper">
              {!newImageLoaded && (
                <div className="image-placeholder shimmer">
                  <div className="placeholder-content">
                    <div className="loading-spinner"></div>
                    <span>Revealing new design...</span>
                  </div>
                </div>
              )}
              <img
                src={newImageUrl}
                alt={`${displayName} - New 2026 Version`}
                className={`product-image ${imageAnimation} ${newImageLoaded ? "loaded" : "loading"}`}
                onDragStart={(e) => e.preventDefault()}
                style={{
                  filter: newImageLoaded ? "blur(0)" : "blur(20px)",
                  opacity: newImageLoaded ? 1 : 0.6,
                  transition: "filter 0.5s ease, opacity 0.5s ease",
                }}
                onLoad={() => setNewImageLoaded(true)}
                onError={(e) => {
                  console.error("Image error, using fallback");
                  e.target.src = fallbackNew;
                }}
              />
            </div>
            <div className="product-info">
              <strong style={{ color: "white", marginBottom: "30px" }}>
                Chocodate Glow Up
              </strong>

              {/* <h1>{displayName}</h1> */}
              {/* <button className="close-btn" onClick={handleExpiry}>
                Finished Preview
              </button> */}
            </div>
          </div>
        )}
        {/* PHASE 3: EXPIRED / THANKS */}
        {stage === "expired" && (
          <div className="expired-view scale-up">
            {localStorage.getItem("productSeen") === qr ? (
              <div className="thanks-ui">
                {/*<div className="icon">✨</div>*/}
                <h1>
                  COMING <em>SOON</em>{" "}
                </h1>
                <span>
                  Your exclusive preview of <br /> {displayName} is complete
                </span>
              </div>
            ) : (
              <div className="used-ui">
                <div className="icon">🔒</div>
                {/* <h2>Invitation Used</h2> */}
                <br />
                <span>
                  This unique link has already been accessed and is now closed.
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
